<!-- eslint-disable max-len -->
<template>
  <svg
    id="draw-mode-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 1.5 17.5 14"
  >
    <path d="m12.04 5.88 3.17 3.17-6.89 6.9-2.83.31a.595.595 0 0 1-.65-.53v-.13l.32-2.83 6.89-6.89Zm5.14-.47-1.49-1.49c-.46-.47-1.22-.47-1.68 0l-1.4 1.4 3.17 3.17 1.4-1.4c.47-.46.47-1.22 0-1.68Z" />
    <path
      d="M3.55 16.84c-.36 0-.71-.15-.96-.44l-.33-.38C1.14 14.74-.94 12.36.48 9.54l.14-.22C1.68 8 2.93 7.84 3.84 7.73c.93-.12 1.55-.19 2.3-1.3.44-1.03-.42-2.96-1.5-4.44-.4-.56-.28-1.34.28-1.75a1.25 1.25 0 0 1 1.75.28C7.6 1.8 9.63 5.06 8.35 7.61l-.08.13c-1.42 2.12-2.98 2.32-4.12 2.46-.77.1-1.13.16-1.5.57-.51 1.17.34 2.28 1.48 3.59.13.15.25.29.36.42.45.53.38 1.32-.15 1.76-.23.2-.52.29-.81.29Z"
      opacity=".3"
    />
  </svg>
</template>

<script>
export default {
  name: 'DrawModeIcon',
};
</script>
